









import Vue, { PropOptions } from 'vue';

type OurStory = Blok & {
  Title: string;
  paragraph: string;
  secondaryParagraph: string;
  tertiaryParagraph: string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<OurStory>,
  },
});
